import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Image,
  TextInput,
} from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { s } from "react-native-size-matters";
import { useContext, useState } from "react";
import { AppImages } from "../utility/AppImages";
import { AppColors } from "../utility/AppColors";
import { CreateResponsiveStyle } from "rn-responsive-styles";

export default function CommonTextInputWeb(props: any) {
  const {
    isRequired = false,
    placeholder = "",
    placeholderTextColor = AppColors.white,
    mainStyle,
    iconStyle,
    inputStyle,
    prefixIconVisibility = false,
    prefixIcon = AppImages.icArrowRight,
    refValue,
    onSubmitEditing,
    onChangeText,
    keyboardType,
    returnKeyType,
    secureTextEntry,
    editable = true,
    value,
    autoCapitalize,
    maxLength,
    isPassword = false,
    rightIcon = AppImages.icArrowRight,
    onPressEyeIcon,
    multiLine = false,
    rightIconStyle,
    showEyeIcon = false,
    onFocus,
  } = props;

  const [isFocused, setIsFocused] = useState(false);
  const [inputTextLength, setInputTextLength] = useState(0);

  const styles = useStyles();

  return (
    <View
      style={[
        styles.viewStyle,
        isFocused && {
          borderWidth: 2,
          borderColor: AppColors.themeColor_0A89AD,
        },
        mainStyle,
      ]}
    >
      {prefixIconVisibility ? (
        <Image style={[styles.iconStyle, iconStyle]} source={prefixIcon} />
      ) : null}
      <TextInput
        ref={refValue}
        placeholder={placeholder}
        multiline={multiLine}
        placeholderTextColor={placeholderTextColor}
        onFocus={() => {
          onFocus();
          if (editable) {
            setIsFocused(true);
          }
        }}
        onBlur={() => setIsFocused(false)}
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          styles.textInputStyle,
          inputStyle,
        ]}
        onSubmitEditing={() => onSubmitEditing()}
        onChangeText={(value) => {
          onChangeText(value);
          setInputTextLength(value.length);
        }}
        keyboardType={keyboardType}
        returnKeyType={returnKeyType}
        secureTextEntry={secureTextEntry}
        editable={editable}
        value={value}
        autoCapitalize={autoCapitalize}
        maxLength={maxLength}
      />
      {showEyeIcon ? (
        <TouchableOpacity
          onPress={() => onPressEyeIcon()}
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Image
            source={rightIcon}
            resizeMode="contain"
            style={[styles.iconStyle, rightIconStyle]}
          />
        </TouchableOpacity>
      ) : null}
      {isRequired ? (
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_30,
            {
              paddingTop: 5,
              paddingRight: 10,
            },
          ]}
        >
          *
        </Text>
      ) : null}
    </View>
  );
}

const useStyles = CreateResponsiveStyle({
  viewStyle: {
    flexDirection: "row",
    gap: 16,
    borderRadius: 8,
  },
  iconStyle: {
    width: s(22),
    height: s(22),
    resizeMode: "contain",
    tintColor: AppColors.white,
  },
  textInputStyle: {
    paddingVertical: 20,
    paddingHorizontal: 22,
    color: AppColors.white,
    flex: 1,
    outlineStyle: "none",
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
  },
});
